// extracted by mini-css-extract-plugin
export default {"Paper":"bookDemoModal_Paper__AXqUa","Backdrop":"bookDemoModal_Backdrop__TXkpd","Card":"bookDemoModal_Card__7ZTSi","CloseBU":"bookDemoModal_CloseBU__yEkie"};